import { z } from 'zod'

import type { NoContext } from '~/services/api/contracts/NoContext'
import { DashboardBrandsQuerySchema, BrandStatusSchema } from '~/services/api/generated'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

// BrandIndexRequest::prepareForValidation
const normalize = fieldNormalizer({
  enums: [{ field: 'status', options: BrandStatusSchema.options }]
})

export const DashboardBrands = (_context: NoContext = {}) =>
  z.preprocess(normalize, DashboardBrandsQuerySchema)
